import React, { useState } from "react";
import LockIcon from "../../common/images-new/lock-gray-icon.svg"
import { Card } from "../../pages/Theme";
import Toggle from "../Button/Toggle";
import GoogleApiWrapper from "./MapGoogle";
import { MdOutlinePublic } from 'react-icons/md'
import { IoMdLock } from 'react-icons/io'

const EditMap = () => {
    const [showMap, setShowMap] = useState(false)
    
    return(
            <Card className={`flex flex-col bg-white w-screen md:w-72 relative absolute md:top-0 md:rounded-lg`}
            >
                <div className="md:mt-4 mb-4 flex flex-row px-3 items-center justify-center md:justify-between">
                    <div className="flex flex-row mr-3 md:mr-0">
                        { showMap === false && <IoMdLock className='w-6 h-6 mr-2'/>}
                        {/* <img className="mr-2 hover:opacity-80 cursor-pointer" src={LockIcon} alt="icon"></img>                         */}
                        <p className="text-base font-bold">My Map</p>
                    </div>
                    <Toggle checked={showMap} onChange={() => setShowMap(!showMap)}/>
                </div>
                
                <div className="flex justify-center">
                    <GoogleApiWrapper />
                </div>           
            </Card>
    )
} 

export default EditMap;
